// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryInformation_container__2iZhe","divider":"PrimaryInformation_divider__1rUPF"};